import { ReactElement } from "jsx-dom";
import { selectAll } from "@fruugo/utilities";
import { getPaymentMethodList } from "./api";

const ariaLabelMap: { [key: string]: string } = {
  Paypal: "PayPal",
  "Paypal Express": "PayPal Express Checkout",
  "Apple Pay": "Apple Pay",
  "Apple Pay Express": "Apple Pay Express Checkout",
  "Google Pay": "Google Pay",
  "Google Pay Express": "Google Pay Express Checkout",
  visa: "Visa",
  mc: "Mastercard",
  maestro: "Maestro",
  amex: "American Express",
  Klarna: "Klarna",
  "Klarna Express Checkout": "Klarna Express Checkout",
  "Klarna Instant": "Klarna Instant",
  discover: "Discover",
  jcb: "JCB",
  Alipay: "Alipay",
};

const paymentMethodSlugBlacklist = [
  "paypalexpress",
  "applepayexpress",
  "googlepayexpress",
  "klarnaexpresscheckout",
  "klarnainstant",
  "unionpay",
];

function isPaymentMethodEnabled(paymentMethod: string) {
  const slug = slugifyName(paymentMethod);
  return !paymentMethodSlugBlacklist.includes(slug);
}

export function loadPaymentMethods(
  forceFetch = false,
  country = window.currentCountry
): Promise<string[]> {
  return new Promise((resolve, reject) => {
    const key = "paymentMethods_" + country;
    const cached = sessionStorage.getItem(key);
    if (cached === null || forceFetch) {
      getPaymentMethodList(
        country === window.currentCountry ? undefined : country
      ).then((paymentMethods) => {
        sessionStorage.setItem(key, JSON.stringify(paymentMethods));
        resolve(paymentMethods);
      }, reject);
    } else {
      resolve(JSON.parse(cached));
    }
  });
}

function slugifyName(name: string) {
  return name.replace(/\s+/g, "").toLowerCase();
}

export function buildIcons(paymentMethods: string[]) {
  return (
    <div class="icon-pay-list">
      {paymentMethods.filter(isPaymentMethodEnabled).map((paymentMethod) => (
        <span
          role="img"
          aria-label={ariaLabelMap[paymentMethod] || paymentMethod}
          className={`icon icon-pay icon-pay--${slugifyName(paymentMethod)}`}
        ></span>
      ))}
    </div>
  );
}

function addIconsToDom(elements: NodeListOf<Element>, icons: ReactElement) {
  elements.forEach((element) => element.replaceChildren(icons.cloneNode(true)));
}

export function initPaymentIcons(
  selector = ".js-payment-icons",
  forceFetch = false
) {
  const elements = selectAll(selector);
  if (elements === null) return;
  loadPaymentMethods(forceFetch)
    .then(buildIcons)
    .then((icons) => addIconsToDom(elements, icons))
    .catch(() => undefined);
}
